export default "__VITE_ASSET__C8ZYl9NO__"